import { extractPreorderData } from '@/lib/checkout/preOrder';

import type { GtmCartCheckoutSource } from './cartLineResolution';
import { buildPreOrderCheckoutExtras } from './preOrder';

export function resolveCheckoutGtmExtras(
  checkout: GtmCartCheckoutSource | null | undefined,
  showTax: boolean
) {
  const preOrderData = extractPreorderData(checkout);
  if (!preOrderData || !checkout?.totalPrice) return undefined;

  const checkoutTotal = showTax
    ? (checkout.totalPrice.gross?.amount ?? 0)
    : (checkout.totalPrice.net?.amount ?? 0);

  return buildPreOrderCheckoutExtras({
    preOrderData,
    checkoutTotal,
    showTax,
  });
}
